import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
type BadgeVariant = 'accent' | 'error' | 'info' | 'neutral' | 'success' | 'warning';
type Stat = {
  label: string;
  value: string;
  badge?: {
    label: string;
    variant?: BadgeVariant;
  };
  description?: string;
};
type StatRowProps = {
  title?: string;
  stats: Stat[];
};
const BADGE_COLOR: Record<BadgeVariant, string> = {
  error: 'text-error',
  warning: 'text-warning',
  success: 'text-success',
  info: 'text-info',
  accent: 'text-accent',
  neutral: 'text-tertiary'
};
const StatRow = t0 => {
  const $ = _c(11);
  const {
    title,
    stats: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const stats = t2;
  let t3;
  if ($[2] !== title) {
    t3 = title && <span className="text-label-2 text-primary fp-text">{title}</span>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== stats) {
    t4 = stats.map(_temp);
    $[4] = stats;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="grid w-full grid-cols-2 max-md:[&>*:last-child:nth-child(odd)]:col-span-2 md:grid-cols-[repeat(auto-fit,minmax(160px,1fr))] gap-px overflow-hidden rounded-md border border-solid border-tertiary bg-senary">{t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <div className="flex flex-col gap-3 w-full">{t3}{t5}</div>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default StatRow;
function _temp(t0, i) {
  const {
    label,
    value,
    badge,
    description
  } = t0;
  return <div key={`${label}-${i}`} className="flex min-w-0 flex-col gap-1.5 bg-primary px-4 py-3"><p className="text-caption-1 text-tertiary fp-text">{label}</p><span className="text-label-1 text-primary fp-text">{value}</span>{badge?.label && <span className={cx("text-caption-1 fp-text", BADGE_COLOR[badge.variant ?? "neutral"])}>{badge.label}</span>}{description && <p className="text-caption-1 text-tertiary fp-text">{description}</p>}</div>;
}